import React from 'react';
import { createPortal } from 'react-dom';
import { Lock } from 'lucide-react';

export default function SalaryHoldModal({ isOpen, onClose, employee }) {
  if (!isOpen || !employee) return null;

  return createPortal(
    <div className="fixed inset-0 z-[999] flex items-center justify-center p-4">
      {/* Blurred background overlay */}
      <div 
        className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity" 
        onClick={onClose}
      ></div>
      
      {/* Modal Container */}
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-[440px] overflow-hidden animate-in fade-in zoom-in-95 duration-200">
        
        {/* Top Header - Light Red Area */}
        <div className="bg-red-50/50 flex flex-col items-center justify-center py-6 border-b border-red-50">
          <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center text-red-500 mb-3 border border-red-200/50 shadow-sm">
            <Lock size={20} strokeWidth={2.5} />
          </div>
          <h2 className="text-xl font-black text-slate-800 tracking-tight">Put Salary On Hold</h2>
          <p className="text-xs font-semibold text-slate-500 mt-1">Salary will be locked until released</p>
        </div>

        {/* Content Body */}
        <div className="p-6 space-y-5">
          
          {/* Employee Info Box */}
          <div className="bg-slate-50/50 border border-slate-200/60 rounded-lg p-3 custom-shadow-inner flex flex-col justify-center">
            <div className="text-[13px] font-bold text-slate-700">
              Employee: <span className="text-slate-900">{employee.name}</span>
            </div>
            <div className="text-[11px] font-semibold text-slate-500 mt-0.5">
              ID: {employee.empId}
            </div>
          </div>

          {/* Reason Textarea */}
          <div className="space-y-1.5">
            <label className="text-[13px] font-bold text-slate-700 block">
              Reason for Hold <span className="text-slate-400">*</span>
            </label>
            <textarea 
              rows="4" 
              placeholder="e.g., Performance Issue, Notice Period, Investigation Pending..."
              className="w-full px-3 py-2.5 bg-white border border-slate-300 rounded-lg text-[13px] text-slate-700 focus:outline-none focus:border-red-400 focus:ring-2 focus:ring-red-400/20 transition-all placeholder:text-slate-400 resize-none shadow-sm"
              required
            ></textarea>
          </div>

          {/* Warning Message Box */}
          <div className="bg-[#fff9eb] border border-[#fde68a] rounded-lg p-3 shadow-sm">
            <p className="text-[11px] font-medium text-[#b45309] leading-relaxed">
              <span className="font-bold text-[#92400e]">Warning:</span> Employee won't receive payment until salary is released from hold.
            </p>
          </div>

        </div>

        {/* Footer Buttons */}
        <div className="px-6 py-4 bg-white flex items-center justify-between gap-3">
          <button 
            type="button" 
            onClick={onClose}
            className="flex-1 px-4 py-2.5 bg-white border border-slate-200 text-slate-600 font-bold text-[13px] rounded-lg hover:bg-slate-50 hover:text-slate-800 transition-colors shadow-sm"
          >
            Cancel
          </button>
          
          <button 
            type="submit" 
            className="flex-1 px-4 py-2.5 bg-[#e10000] border border-[#d10000] text-white font-bold text-[13px] rounded-lg hover:bg-[#cc0000] transition-colors shadow-sm flex items-center justify-center gap-2"
          >
            <Lock size={16} strokeWidth={2.5} /> Put on Hold
          </button>
        </div>

      </div>
    </div>,
    document.body
  );
}
